import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: '#009587',
        secondary: '#4D4D4D',
        accent: '#009688',
        error: '#ff3547',
        info: '#33b5e5',
        success: '#00c851',
        warning: '#fb3',
      },
    },
  },
  rtl: true,
});
